<template>
    <AppLayout>
        <div class="container flex flex-col justify-center p-4 mx-auto md:w-3/4">
            <div class="mb-4 font-bold md:text-2xl">
                {{ isWholesaler ? 'Manage Credit Request' : 'Request Credit' }}
            </div>
            <div class="px-4 py-6 bg-white border rounded">
                <!-- Wholesaler selection (only visible to retailer) -->
                <div v-if="!isWholesaler" class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-8">
                    <div class="w-1/4">
                        Wholesaler
                    </div>
                    <div class="w-3/4">
                        <t-rich-select v-model="form.wholesalerId" :clearable="true" :options="wholesalerList"
                            value-attribute="id" text-attribute="name" placeholder="Select Wholesaler"
                            :variant="errors('wholesaler_id') ? 'danger' : ''" />
                    </div>
                </div>

                <!-- Requested By (readonly for wholesaler) -->
                <div v-if="isWholesaler" class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-2">
                    <div class="w-1/4">Requested By</div>
                    <div class="w-3/4 text-gray-800 font-semibold">
                        {{ originalRequest.user.name }}
                    </div>
                </div>

                <!-- Requested Amount (readonly for wholesaler) -->
                <div v-if="isWholesaler" class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-2">
                    <div class="w-1/4">Requested Amount</div>
                    <div class="w-3/4 text-gray-800 font-semibold">
                        {{ formatCurrency(originalRequest.amount) }}
                    </div>
                </div>

                <!-- Amount to Approve or Request -->
                <div class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-8">
                    <div class="w-1/4">
                        {{ isWholesaler ? 'Approve Amount' : `Amount (${config(common.currency)})` }}
                    </div>
                    <div class="w-3/4">
                        <t-input v-model.number="form.amount" type="number"
                            :placeholder="isWholesaler ? 'Amount to approve' : 'How much credit do you want?'" />
                    </div>
                </div>

                <div class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-8">
                    <div class="w-1/4">
                        Message
                    </div>
                    <div class="w-3/4">
                        <t-textarea v-model="form.message" 
                        :placeholder="isWholesaler ? 'Message' : 'Say something to the wholesaler' " rows="5" />
                    </div>
                </div>
                <!-- Action buttons -->
                <div class="flex items-center justify-end gap-2">
                    <template v-if="isWholesaler">
                        <Button text="Reject" color="red" @onClick="rejectRequest" />
                        <Button text="Approve" color="green" @onClick="approveRequest" />
                    </template>
                    <template v-else>
                        <Button text="Send Request" color="green" @onClick="submitForm" />
                    </template>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import Button from '@/Components/Button.vue';
import common from '@/common';

export default {
    name: 'CreditRequestForm',

    components: {
        AppLayout,
        Button,
    },

    props: {
        wholesalerList: {
            type: Array,
            required: true,
        },
        originalRequest: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            common,
            form: {
                wholesalerId: this.originalRequest.wholesaler_id || null,
                amount: this.originalRequest.amount || null,
                message: null,
            },
        };
    },

    watch: {
        rightSidebar(newVal) {
            if (newVal === false) {
                this.editData = null;
            }
        },

    },

    methods: {
        formatCurrency(amount) {
            return `${this.config(this.common.currency)} ${Number(amount).toFixed(2)}`;
        },

        submitForm() {
            const payload = this.buildPayload();
            this.save(payload);
        },

        buildPayload() {
            const formData = new FormData();
            if (this.form.wholesalerId) {
                formData.append('wholesaler_id', this.form.wholesalerId);
            }
            if (this.form.amount) {
                formData.append('amount', parseInt(this.form.amount));
            }
            if (this.form.message) {
                formData.append('message', this.form.message);
            }
            if (this.editData) {
                formData.append('_method', 'PUT');
            }
            return formData;
        },

        save(payload) {
            this.$inertia.post(route('creditRequest.store'), payload);
        },

        approveRequest() {
            this.$inertia.post(`/credits/approve/${this.originalRequest.id}`, {
                approved_amount: this.form.amount,
                message: this.form.message,
            });
        },
        rejectRequest() {
            this.$inertia.post(`/credits/reject/${this.originalRequest.id}`, {
                message: this.form.message,
            });
        },
    },
};
</script>
